<ng-container *ngIf="paystub">
    <table>
        <colgroup>
            <col span="2" />
            <col span="2" />
            <col span="2" />
        </colgroup>
        <thead>
            <tr>
                <th></th>
                <th scope="colgroup">{{ 'forms.payroll-review.grossPay' | translate }}</th>
                <th></th>
                <th scope="colgroup">{{ 'forms.payroll-review.deductions' | translate }}</th>
                <th></th>
                <th scope="colgroup">{{ 'forms.payroll-review.netPay' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows; let i = index">
                <!-- Earnings data column-->
                <ng-container
                    *ngIf="payItems[i] as payItem; else blankRow"
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{
                        title: payItem.displayName,
                        amount: payItem.amount,
                    }"
                />
                <!-- Deductions data column-->
                <ng-container
                    *ngIf="this.deductions[i] as deduction; else blankRow"
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{
                        title: deduction.displayName || (deduction.name ?? ''),
                        amount: deduction.current,
                        isIncomeTax: deduction.isIncomeTax,
                    }"
                />
                <!-- Nothing for the net pay column, it is always empty-->
                <ng-container [ngTemplateOutlet]="blankRow" />
            </tr>
        </tbody>
        <tfoot>
            <!-- Individual total columns (gross, deductions, net)-->
            <tr>
                <ng-container
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{ title: 'forms.payroll-review.total.gross', amount: paystub.grossPay }"
                />
                <ng-container
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{
                        title: 'forms.payroll-review.total.deductions',
                        amount: paystub.deductionsAmount,
                    }"
                />
                <ng-container
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{
                        title: 'forms.payroll-review.total.net',
                        amount: paystub.depositAmount,
                    }"
                />
            </tr>
            <!-- Final row for reimbursements-->
            <tr>
                <ng-container [ngTemplateOutlet]="blankRow" />
                <ng-container [ngTemplateOutlet]="blankRow" />
                <ng-container
                    [ngTemplateOutlet]="tableCell"
                    [ngTemplateOutletContext]="{
                        title: 'forms.payroll-review.reimbursements',
                        amount: paystub.reimbursementAmount,
                    }"
                />
            </tr>
        </tfoot>
    </table>
</ng-container>

<!-- Each cell in the table is rendered in the same way. To reduce code duplication, an ng-template is used to repeat the pattern-->
<ng-template #tableCell let-amount="amount" let-title="title" let-isIncomeTax="isIncomeTax">
    <!-- On desktop the headers are their own column, however, to reduce space on mobile they move inside the data cell-->
    <th [class.income-tax]="isIncomeTax" scope="row">{{ title | translate }}</th>
    <td>
        <div class="mobile-title">{{ title | translate }}</div>
        {{ amount | currency }}
    </td>
</ng-template>

<!-- Blank rows often need to be rendered, again this is provided for convenience-->
<ng-template #blankRow>
    <th scope="row"></th>
    <td></td>
</ng-template>
